<template>
  <div class="embryo">
    <div class="loading-box" v-if="isLoading">
      <van-loading type="spinner" color="#1989fa" vertical
        >数据正在路上～</van-loading
      >
    </div>
    <div v-else>
      <div class="embryo-info" v-for="(item, index) in embryoData" :key="index">
        <h1>
          {{ item.geneName }}
          <span
            :style="{
              color: textColor[item.genetronInfChinese],
              background: color[item.genetronInfChinese],
            }"
            >{{ item.genetronInfChinese }}</span
          >
        </h1>
        <div class="show-box"></div>
        <div class="flex-content">
          <div class="l">
            <div>
              <p>氨基酸</p>
              <h2>{{ item.proteinChange }}</h2>
            </div>
            <div>
              <p>纯合/杂合</p>
              <h2>{{ item.homHetChinese }}</h2>
            </div>
            <div>
              <p>染色体</p>
              <h2>{{ item.fullChromosome }}</h2>
            </div>
            <div>
              <p>转录本</p>
              <h2>{{ item.refseqMrnaId }}</h2>
            </div>
          </div>
          <div class="r">
            <div>
              <p>核苷酸</p>
              <h2>{{ item.cdnaChange }}</h2>
            </div>
            <div>
              <p>频率</p>
              <h2>
                {{
                  item.normalMutantFrequency === ""
                    ? item.normalMutantFrequency
                    : item.normalMutantFrequency + "%"
                }}
              </h2>
            </div>
            <div>
              <p>外显子</p>
              <h2>{{ item.exon }}</h2>
            </div>
            <div>
              <p>突变类型</p>
              <h2>{{ item.variantClassificationChinese }}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="result">
        <h1>结果解析</h1>
        <div class="show-box"></div>
        <div class="null-box" v-if="isEmpty">
          <van-empty
            class="custom-image"
            :image="require('../../assets/null-data.png')"
            description="暂无数据"
          />
        </div>
        <p v-html="textJiexi"></p>
      </div>
    </div>
  </div>
</template>
<script>
import { embryo, Jiexi } from "@/api/reportQuery";
import { mapState } from "vuex";
import { Toast } from "vant";
export default {
  name: "embryo",
  data() {
    return {
      isEmpty: false,
      isLoading: true,
      embryoData: [],
      color: {
        致病: "#FFF0F3",
        可能致病: "#FFF8EE",
        意义未明: "#F4F1FF",
      },
      textColor: {
        致病: "#FF627F",
        可能致病: "#FFB026",
        意义未明: "#7C67E6",
      },
      textJiexi: "",
    };
  },
  computed: {
    ...mapState("embry", ["params"]),
  },
  mounted() {
    // this.getInfoData();
  },
  methods: {
    async getInfoData(geneName, cdnaChange, fname, fid) {
      try {
        this.isLoading = false;
        let { data } = await embryo({
          geneName: geneName,
          cdnaChange: cdnaChange,
          labOriginalSampleNo: fname,
          productId: fid,
        });
        console.log(data);
        this.embryoData = data;
      } catch (error) {
        Toast(error.message);
      }
    },
    //
    async getJiexi(geneName, cdnaChange, fname, fid) {
      try {
        let { data } = await Jiexi({
          geneName: geneName,
          cdnaChange: cdnaChange,
          labOriginalSampleNo: fname,
          productId: fid,
        });
        console.log(data, "jieguojiexi");
        this.textJiexi = data;
        if (data == "") {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      } catch (error) {}
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log("进入页面");
    window.NativeCallJS = (res) => {
      let par = JSON.parse(res);
      console.log(par, "移动端给的值");
      next((vm) => {
        vm.getInfoData(par.geneName, par.cdnaChange, par.fname, par.fid);
        vm.getJiexi(par.geneName, par.cdnaChange, par.fname, par.fid);
      });
    };
  },
};
</script>
<style lang="less" scoped>
.loading-box {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.embryo {
  padding: 16px;
  font-family: @family;
  .result {
    background: @background_color;
    border-radius: 10px;
    p {
      padding: 0 24px 24px;
      font-size: 15px;
      font-weight: 400;
      color: #5f697d;
      line-height: 30px;
    }
    h1 {
      font-size: 18px;
      font-weight: 500;
      color: #2f354d;
      line-height: 70px;
      padding-left: 24px;
    }
  }
  .embryo-info {
    height: 346px;
    background: @background_color;
    border-radius: 10px;
    margin-bottom: 20px;
    .flex-content {
      display: flex;
      padding-left: 24px;
      .l,
      .r {
        width: 50%;
        div {
          margin-bottom: 20px;
        }
      }
      p {
        font-size: 12px;
        font-weight: 400;
        color: #a4a9bf;
        line-height: 17px;
        margin-bottom: 4px;
      }
      h2 {
        font-size: 13px;
        font-weight: 500;
        color: #2f354d;
        line-height: 18px;
      }
    }
    h1 {
      height: 70px;
      font-size: 18px;
      font-weight: 500;
      color: #2f354d;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 24px;
      span {
        // width: 44px;
        padding: 0 6px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        margin-right: 24px;
      }
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        margin-top: -7px;
        left: 0;
        width: 3px;
        height: 14px;
        background: #2f354d;
        border-radius: 0px 2px 2px 0px;
      }
    }
  }
  .show-box {
    height: 20px;
    background: linear-gradient(
      360deg,
      rgba(58, 74, 134, 0) 0%,
      rgba(58, 74, 134, 0.06) 100%
    );
    margin-bottom: 10px;
  }
}
</style>
